import { DrinkVariant } from './_types';

type DrinkSpinnerProps = {
    variant: DrinkVariant;
}

const DrinkSpinner = ({ variant }: DrinkSpinnerProps): JSX.Element => {
    const hasFoam = false;
    const hasBubbles = variant === 'lemonade';
    const hasIce = variant === 'lemonade' 
                || variant === 'orange-juice';

    return (
        <div className={`drink-spinner drink-spinner--${variant}`}>
            <div className="drink-spinner__stream" />
            <div className="drink-spinner__glass">
                <div className="drink-spinner__liquid">
                    {hasFoam && <div className="drink-spinner__foam" />}
                    {hasBubbles && (
                        <>
                            <div className="drink-spinner__bubble drink-spinner__bubble--1" />
                            <div className="drink-spinner__bubble drink-spinner__bubble--2" />
                            <div className="drink-spinner__bubble drink-spinner__bubble--3" />
                        </>
                    )}
                    {hasIce && (
                        <>
                            <div className="drink-spinner__ice drink-spinner__ice--1" />
                            <div className="drink-spinner__ice drink-spinner__ice--2" />
                        </>
                    )}
                </div>
            </div>
        </div>
    )
}

export default DrinkSpinner;
